<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading">
    <p class="font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-black">Price Update Requests</p>


    <div class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg overflow-x-auto">
        <div class="flex flex-row items-center justify-between">
            <div class="flex flex-col justify-between">
                <p class="font-semibold text-lg mb-1 dark:text-white">Price Update Requests on {{today}}</p>
            </div>
            <div class="flex flex-row items-center gap-8 ">
                <i class="fa-solid fa-list text-[#4A4A4A] text-lg dark:text-white ml-8"></i>

                <p class="text-[#4A4A4A] dark:text-white whitespace-nowrap">Filter By</p>

                <div class="relative w-36 custom-grade-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectGrade" class="hidden" (change)="filterGrade()">
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="A">A</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="B">B</option>
                        <option class=" dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="C">C</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleGradeDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                            <span>{{ selectGrade || 'Grade' }}</span>
                            <div class="flex items-center ">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectGrade" (click)="cancelGrade($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isGradeDropdownOpen || !selectGrade"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isGradeDropdownOpen"
                                    [class.fa-angle-up]="isGradeDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isGradeDropdownOpen"
                        class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                        <div class="">
                            <div *ngFor="let option of gradeDropdownOptions; let i = index"
                                (click)="selectGradeOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === gradeDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="relative w-36 custom-status-dropdown-container">
                    <!-- Hidden native select -->
                    <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Pending">Pending</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Approved">Approved</option>
                        <option class="dark:bg-[#292929] text-textLight dark:text-textDark hover:bg-gray-300"
                            value="Rejected	">Rejected</option>
                    </select>

                    <!-- Custom dropdown trigger -->
                    <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                        (click)="toggleStatusDropdown()">
                        <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                            <span>{{ selectStatus || 'Status' }}</span>
                            <div class="flex items-center ">
                                <!-- X icon (shown ONLY when option is selected) -->
                                <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                                    class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                                <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                                <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                    class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                    [class.fa-angle-down]="!isStatusDropdownOpen"
                                    [class.fa-angle-up]="isStatusDropdownOpen"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Custom dropdown options -->
                    <div *ngIf="isStatusDropdownOpen"
                        class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                        <div class="">
                            <div *ngFor="let option of statusDropdownOptions; let i = index"
                                (click)="selectStatusOption(option)"
                                class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center"
                                [ngClass]="{
                                    'rounded-t-xl': i === 0,
                                    'rounded-b-xl': i === statusDropdownOptions.length - 1
                                  }">
                                <span class="flex-grow">{{ option }}</span>
                                <i
                                    class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="flex items-center mr-5 rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                    <input type="text" placeholder="Search by Crop / Variety name.." [(ngModel)]="searchText"
                        (keyup.enter)="onSearch()" (input)="trimmedSearchText()" (keyup.esc)="offSearch()"
                        class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                        (click)="onSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                        </svg>
                    </button>
                    <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                        (click)="offSearch()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

            </div>

        </div>

        <button class="bg-[#415CFF] text-white font-semibold px-4 py-2 rounded-lg shadow-lg"
            (click)="openAddRequest()">Add
            Request</button>
        <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6 ">
            <p class="text-[#494949] my-6 dark:text-textDark">--No Data Availabale--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
        </div>

        <div *ngIf="hasData" class="min-w-max overflow-hidden  mt-5 mr-5">
            <div class=" border-gray-100 border-[2px] dark:border-[#202021] rounded-lg">
                <table class="w-full min-w-max divide-y-2 border-collapse">
                    <thead
                        class="text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default text-[14px]">
                        <tr>
                            <th class="px-6 py-3 text-left font-medium">No</th>
                            <th class="px-6 py-3 text-left font-medium">Crop Name</th>
                            <th class="px-6 py-3 text-left font-medium">Variety Name</th>
                            <th class="px-6 py-3 text-left font-medium">Grade</th>
                            <th class="px-6 py-3 text-left font-medium">Requested (Rs.)</th>
                            <th class="px-6 py-3 text-center font-medium">Status</th>
                            <th class="px-6 py-3 text-left font-medium">EMP ID</th>
                            <th class="px-6 py-3 text-left font-medium">Time</th>
                            <th class="px-6 py-3 text-left font-medium">View</th>
                            <th class="px-6 py-3 text-left font-medium">Forward</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F] cursor-default">
                        <tr *ngFor="let item of reqPriceArr | paginate: {
                        itemsPerPage: itemsPerPage,
                        currentPage: page,
                        totalItems: totalItems
                    }; let i = index">
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                                {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i +
                                    1) : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.cropNameEnglish}}</td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.varietyNameEnglish}}</td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.grade}}</td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                                {{ item.requestPrice | number:'1.2-2' }}
                            </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300 flex justify-center items-center">
                                <span *ngIf="item.status === 'Pending'"
                                    class="bg-[#F8FFA6] text-[#A8A100] text-center rounded-lg px-6 py-1 ">
                                    Pending
                                </span>
                                <span *ngIf="item.status === 'Approved'"
                                    class="bg-[#C8E0FF] text-[#415CFF] text-center rounded-lg px-4 py-1 ">
                                    Approved
                                </span>
                                <span *ngIf="item.status === 'Rejected'"
                                    class="bg-[#FFB9B7] text-[#D16D6A] text-center rounded-lg px-5 py-1 ">
                                    Rejected
                                </span>
                            </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">
                                {{ item.empId.startsWith('CCM') ? 'You' : item.empId }}
                            </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300">{{item.createdAt | date: 'hh:mm
                                a'}}
                            </td>
                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300 text-center">
                                <button (click)="openChangeStatusPopUp(item.id, item.requestPrice, item.price)" [disabled]="
                                item.assignRole === 'CCH' ||
                                item.empId.startsWith('CCM') ||
                                item.status !== 'Pending'
                              " [ngClass]="{
                                'text-gray-400 cursor-not-allowed':
                                  item.assignRole === 'CCH' ||
                                  item.empId.startsWith('CCM') ||
                                  item.status !== 'Pending',
                                'text-blue-500 hover:text-blue-700':
                                  item.assignRole !== 'CCH' &&
                                  !item.empId.startsWith('CCM') &&
                                  item.status === 'Pending'
                              }" class="p-2 transition">
                                    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" [attr.stroke]="
                                  item.assignRole === 'CCH' ||
                                  item.empId.startsWith('CCM') ||
                                  item.status !== 'Pending'
                                    ? '#9CA3AF'  
                                    : '#415CFF'  
                                ">
                                        <path
                                            d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14M17 14C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14Z"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </button>
                            </td>

                            <td class="px-6 py-4 text-gray-900 dark:text-gray-300 text-center">
                                <button
                                    [disabled]="item.assignRole === 'CCH' || item.empId.startsWith('CCM') || item.status !== 'Pending'"
                                    [ngClass]="{
                                'text-gray-400 cursor-not-allowed':
                                  item.assignRole === 'CCH' ||
                                  item.empId.startsWith('CCM') ||
                                  item.status !== 'Pending',
                                'text-blue-500 hover:text-blue-700':
                                  item.assignRole !== 'CCH' &&
                                  !item.empId.startsWith('CCM') &&
                                  item.status === 'Pending'
                              }" class="p-2 transition" (click)="forwardRequest(item.id)">
                                    <i class="fa-solid fa-share"></i>
                                </button>
                            </td>

                        </tr>
                    </tbody>

                </table>
            </div>
            <div *ngIf="hasData" class="flex justify-end items-center my-5 pt-3 dark:bg-[#1D1D1F] text-right">
                <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"
                    [previousLabel]="'Previous'" [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'"
                    [screenReaderPageLabel]="'page'" [screenReaderCurrentLabel]="'Youre on page'">
                </pagination-controls>
            </div>
        </div>





    </div>
</div>




<div *ngIf="isForwardViewOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-[#363636] shadow-lg rounded-lg px-6 py-10 w-1/3">

        <div>
            <!-- Icon -->
            <div
                class="flex items-center justify-center bg-[#F6F7F9] rounded-lg shadow-sm px-4 mb-3 py-3 mx-auto w-[70px]">
                <i class="fa-solid fa-triangle-exclamation text-[#6B7D8C] text-4xl px-1"></i>
            </div>

            <div class="mb-8 text-center dark:text-textDark">
                <p class="text-lg mb-2">
                    Are you sure you want to forward the request?
                </p>

            </div>

            <!-- Buttons -->
            <div class="flex justify-center gap-6">
                <button class="bg-[#E8E8E8] border-[1px] border-[#6B7D8C] px-10 py-0.35 rounded-lg shadow-md"
                    (click)="cancelForward()"><span class="font-semibold text-[#6B7D8C]">No,</span> <br>
                    <span class="text-light text-whight-700 button-text text-[#6B7D8C]">Go Back</span>
                </button>
                <button class="bg-[#415CFF] border-[1px] border-[#415CFF] px-10 py-0.35 rounded-lg shadow-md"
                    (click)="confirmForward()"><span class="font-semibold text-white">Yes,</span> <br>
                    <span class="text-light text-whight-700 button-text text-white">Forward</span>
                </button>
            </div>
        </div>
    </div>

</div>


<div *ngIf="isAddRequestOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ">
    <div class="bg-white  shadow-lg rounded-lg p-6 w-1/4 dark:bg-[#363636]">
        <div class="px-6">
            <h2 class="text-lg font-semibold text-center mb-2 dark:text-white">Request a Price Update</h2>
            <p class="text-sm text-gray-500 text-center mb-4 dark:text-textDark">
                This will directly go to your Collection Centre <br />
                Head Officer.
            </p>

            <label for="crop" class="block text-sm font-medium text-gray-700 mb-2 dark:text-textDark ">
                Select Crop
            </label>

            <app-searchable-dropdown [items]="cropGroupDropdownItems" placeholder="Select Crop"
                searchPlaceholder="Search Crops..." [(ngModel)]="priceRequestObject.cropGroupId"
                (selectionChange)="onCropGroupSelectionChange($event)" [clearable]="true" [showSelected]="true"
                [disabled]="false" class="block w-full mb-4"></app-searchable-dropdown>

            <label for="variety" class="block text-sm font-medium text-gray-700 mb-2 dark:text-textDark ">
                Select Variety
            </label>

            <app-searchable-dropdown [items]="cropVarietyDropdownItems" placeholder="Select Variety"
                searchPlaceholder="Search Varieties..." [(ngModel)]="priceRequestObject.cropVarietyId"
                (selectionChange)="onCropVarietySelectionChange($event)" [clearable]="true" [showSelected]="true"
                [disabled]="false" class="block w-full mb-4"></app-searchable-dropdown>

            <label for="grade" class="block text-sm font-medium text-gray-700 mb-2 dark:text-textDark ">
                Select Grade
            </label>

            <app-searchable-dropdown [items]="gradeDropDownItems" placeholder="Select Grade"
                searchPlaceholder="Search..." [(ngModel)]="priceRequestObject.grade"
                (selectionChange)="onGradeSelectionChange($event)" [clearable]="true" [showSelected]="true"
                [disabled]="false" class="block w-full mb-4"></app-searchable-dropdown>

            <label for="curPrice" class="block text-sm font-medium text-gray-700 mb-2 dark:text-textDark ">
                Current Market Price (Rs.)
            </label>

            <input type="number" id="curPrice" name="curPrice"
                [ngModel]="priceRequestObject.currentPrice | number:'1.2-2'" placeholder="   --" disabled
                class="w-full border  mb-4 border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-[#292929] dark:text-white dark:border-gray-600" />


            <label for="requstPrice" class="block text-sm font-medium text-gray-700 mb-2 dark:text-textDark ">
                Requesting Price (Rs.)
            </label>

            <input type="number" id="requstPrice" name="requstPrice" [(ngModel)]="priceRequestObject.requstPrice"
                placeholder="Type Here.." min="0" (keydown)="preventMinus($event)" (click)="log()"
                class="w-full border mb-2 border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-[#292929] dark:text-white dark:border-gray-600" />

            <!-- Buttons -->
            <div class="flex justify-center space-x-4 mt-4">
                <button (click)="closeAddRequest()"
                    class="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-2 focus:ring-gray-200 dark:bg-[#292929] dark:text-white dark:hover:bg-gray-100 dark:hover:text-black">
                    Cancel
                </button>
                <button (click)="submitRequest()"
                    [disabled]="!priceRequestObject.requstPrice || !priceRequestObject.currentPrice" [ngClass]="{
                      'bg-blue-500 hover:bg-blue-600 text-white': priceRequestObject.requstPrice && priceRequestObject.currentPrice,
                      'bg-gray-400 text-gray-200 cursor-not-allowed': !priceRequestObject.requstPrice || !priceRequestObject.currentPrice
                    }" class="px-4 py-2 rounded-lg focus:ring-2 focus:ring-blue-300 transition-colors duration-200">
                    Submit
                </button>
            </div>
        </div>
    </div>


</div>



<div *ngIf="isChangeStatusViewOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    (click)="closeChangeStatus()">
    <div class="bg-white dark:bg-[#363636] shadow-lg rounded-lg px-6 py-10 w-1/3">

        <div>
            <!-- Icon -->
            <div
                class="flex items-center justify-center bg-[#F6F7F9] rounded-lg shadow-sm px-4 mb-3 py-3 mx-auto w-[70px]">
                <i class="fa-solid fa-triangle-exclamation text-[#6B7D8C] text-4xl px-1"></i>
            </div>

            <div class="mb-8 text-center dark:text-textDark">
                <p class="text-lg mb-2">
                    Please select an action to proceed.
                </p>

            </div>

            <!-- Buttons -->
            <div class="flex justify-center gap-6">
                <button class="bg-[#FF0000] border-[1px] border-[#CA0000] h-12 px-10 rounded-xl shadow-md"
                    (click)="RejectStatus()"><span class="font-semibold text-[#FFFFFF]">Reject</span>
                </button>
                <button class="bg-[#415CFF] border-[1px] border-[#415CFF] h-12 px-10 rounded-xl shadow-md"
                    (click)="ApproveStatus()"><span class="font-semibold text-[#FFFFFF]">Approve</span>
                </button>
            </div>
        </div>
    </div>

</div>